import createLucideIcon from '../createLucideIcon';

const User2 = createLucideIcon('User2', [
  ['circle', { cx: '12', cy: '8', r: '5', key: '1hypcn' }],
  ['path', { d: 'M20 21a8 8 0 1 0-16 0', key: '199sx2' }],
]);

export default User2;
